import { useId } from "react";

export const LogoMark = ({ className = "h-8 w-8", color = "#D4FF3A", dot = true }) => {
  const id = `sfu-${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={color} />
          <stop offset="1" stopColor={color} stopOpacity="0.15" />
        </linearGradient>
      </defs>
      <path d="M42 20a10 10 0 1 0-10 12a10 10 0 1 1-10 12" fill="none" stroke={`url(#${id})`} strokeWidth="7" strokeLinecap="round" />
      {dot && <circle cx="50" cy="50" r="3.2" fill={color} />}
    </svg>
  );
};
